import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/table"

import useClanKinshipData from "../../hooks/useClanKinshipData"

const ClanKinship = () => {
	const data = useClanKinshipData()

  const columns = [
    { name: "Kinship", key: "kinship" },
    { name: "Chinese Name", key: "ccchi" },
    { name: "English Name", key: "cceng" },
  ]

  return (
    <Layout>
      <Seo title="Index of Kinship-based Chinese Clan Associations" />

      <Container>
			<h1>Index of Kinship-based Chinese Clan Associations</h1>

      <Table
        columns={columns}
        data={data}
        paginationSize={15}
				routeLink={() => "/map"}
				routeState={({ id }) => ({ clanId: id, clanType: "K" })}
      />
      </Container>

    </Layout>
  )
}

export default ClanKinship
